import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import {default as Reactsel} from 'react-select';
import { ListItemGraphic} from 'rmwc/List';
import UserUploadedResComponent from '../learning_resource_user/UserUploadedResComponent';
import PaginationComponent from '../PaginationComponent';

class UserSegregatedResource extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
    		pageNo: 1,
    		totalCount: '',
    		data:{
                resourceDetails: []
    		},
    		itemsPerPage: 10,
    	}
    }

    componentDidMount() {
    	this.handleResourceFetch(this.state.pageNo)
    }

    handleResourceFetch = (pageNo) => {
    	if(pageNo === undefined) {
    		pageNo = this.state.pageNo
    	}
    	let data = Object.assign({}, this.state.data)
    	let fetchUserResource = `admin/user_resource/render_all_resources/${this.props.status}/${pageNo}/${this.state.itemsPerPage}/${this.props.resourceType}/${this.props.partnerId}`

    	return api.getResponse(this.props.user.accessToken, fetchUserResource)
    	.then((result) => {
    		if (result.status === 'success'){
    			data.resourceDetails = result.data
    			let totalCount = result.total_count
    			this.setState({data: data, totalCount: totalCount})
    		}
    	})	
    }

    render(){
    	let resourceComponent, isPartner
    	let handleResourceFetch = this.handleResourceFetch
        if (this.props.resourceType === 'Affiliate') {
            isPartner = true
        }
        else {
            isPartner = false
        }

        if (this.props.resourceType === 'User') {
        	if (this.state.data.resourceDetails.length > 0) {
        		resourceComponent = (
        			<Grid className="opportunity-list-item">
        				{this.state.data.resourceDetails.map(function(resource){
                            let uniq = Math.random() * resource.id
                            let migrationStatus = "Not Migrated"
                            return (
                                <GridCell span = "12" key = {uniq}>
                                    <Card style={{padding: '0px'}}>
                                        <UserUploadedResComponent resourceId = {resource.id}
                                        	submittedUserName = {resource.user_name}
                                        	submittedUserId = {resource.user_id}
                                        	resourceStatus = {resource.status}
                                            resourceName = {resource.name}
                                            resourceAuthor = {resource.author}
                                            resourceDescription = {resource.description}
                                            resourceLink = {resource.resource_link}
                                            resourceType = {resource.resource_type}
                                            aspects = {resource.aspects}
                                            migrationStatus = {resource.migration_status}
                                            standards = {resource.standards}
                                            submissionDate = {resource.submitted_at}
                                            onHandleUpdateActivity = {handleResourceFetch}
                                            isAdmin = {true}
                                            isPartner = {isPartner}
                                        />
                                    </Card>
                                </GridCell>
                            )
                        })}
        			</Grid>
        		)
        	}
        }
        else {
            if (this.state.data.resourceDetails.length > 0) {
                resourceComponent = (
                    <Grid className="opportunity-list-item">
                        {this.state.data.resourceDetails.map(function(resource){
                            let uniq = Math.random() * resource.id
                            let migrationStatus = "Not Migrated"
                            return (
                                <GridCell span = "12" key = {uniq}>
                                    <Card style={{padding: '0px'}}>
                                        <UserUploadedResComponent resourceId = {resource.id}
                                            submittedUserName = {resource.user_name}
                                            submittedUserId = {resource.user_id}
                                            resourceStatus = {resource.status}
                                            resourceName = {resource.name}
                                            resourceAuthor = {resource.author}
                                            resourceDescription = {resource.description}
                                            resourceLink = {resource.resource_link}
                                            resourceType = {resource.resource_type}
                                            aspects = {resource.aspects}
                                            migrationStatus = {resource.migration_status}
                                            standards = {resource.standards}
                                            grades = {resource.grades}
                                            buzzwords = {resource.buzzwords}
                                            submissionDate = {resource.submitted_at}
                                            onHandleUpdateActivity = {handleResourceFetch}
                                            isAdmin = {true}
                                            isPartner = {isPartner}
                                        />
                                    </Card>
                                </GridCell>
                            )
                        })}
                    </Grid>
                )
            }
        }

    	return(
    		<div>
    			{resourceComponent}
    			<div key={this.state.totalCount}>
		      		<PaginationComponent totalItems = {this.state.totalCount}
	      				itemsPerPage = {this.state.itemsPerPage} 
	      				onHandleItemsFetch = {handleResourceFetch} />
		      	</div>
    		</div>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserSegregatedResource);


// WEBPACK FOOTER //
// ./src/views/learning_resource_admin/UserSegregatedResource.jsx